var Shopify = Shopify || {};
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }
  return formatString.replace(placeholderRegex, value);
};

const bundle_metadata = {
  items: {},
};

function getBundleItemQuantity(id) {
  return (
    (bundle_metadata.items[id] = bundle_metadata.items[id] || {
      quantity: 0,
    }),
    bundle_metadata.items[id].quantity
  );
}

function saveToBundleMetadata(id, quantity = 1) {
  bundle_metadata.items[id] = bundle_metadata.items[id] || { quantity: 0 };
  bundle_metadata.items[id].quantity += quantity;

  let totalItemsInBundle = 0;

  Object.keys(bundle_metadata.items).forEach(function (variant_id) {
    const item = document.querySelector(`.bb-free-bag-item[data-variant-id="${variant_id}"]`);
    const qtyInput = document.querySelector(`.bb-free-bag-item[data-variant-id="${variant_id}"] .bb-quantity input`);
    const addBtn = document.querySelector(`.bb-free-bag-item[data-variant-id="${variant_id}"] .bb-add-product-bundle`);

    if (bundle_metadata.items[variant_id].quantity > 0) {
      if (item) item.classList.add("bb-added-to-bundle");
      if (qtyInput) qtyInput.value = bundle_metadata.items[variant_id].quantity;
    } else {
      if (item) item.classList.remove("bb-added-to-bundle");
      if (qtyInput) qtyInput.value = 1;
    }

    const maxQuantity = item ? parseInt(item.getAttribute("data-max")) : 0;
    if (maxQuantity > 0) {
      if (bundle_metadata.items[variant_id].quantity >= maxQuantity) {
        if (addBtn) { addBtn.classList.add("disabled"); addBtn.setAttribute("disabled", "disabled"); }
      } else {
        if (addBtn) { addBtn.classList.remove("disabled"); addBtn.removeAttribute("disabled"); }
      }
    }

    totalItemsInBundle += bundle_metadata.items[variant_id].quantity;
  });

  if (totalItemsInBundle >= 5) {
    document.querySelectorAll(".bb-add-product-bundle").forEach(function (btn) {
      btn.classList.add("disabled");
      btn.setAttribute("disabled", "disabled");
    });
  } else {
    document.querySelectorAll(".bb-add-product-bundle").forEach(function (btn) {
      btn.classList.remove("disabled");
      btn.removeAttribute("disabled");
    });
  }
}

function updateBundlePrice() {
  const activeItems = document.querySelectorAll(".bb-item-active");
  let $quantity = activeItems.length;
  let totalPrice = 0;

  // Calculate base total price
  activeItems.forEach(function (item) {
    const variantId = item.dataset.variantId;
    const itemEl = document.querySelector(`.bb-free-bag-item[data-variant-id="${variantId}"]`);
    const itemPrice = itemEl ? parseFloat(itemEl.dataset.price) : 0;
    totalPrice += itemPrice;
  });

  let priceChange = 1;
  let subscriptionPriceChange = 1;

  // Update item count
  document.querySelectorAll(".added-items-heading .add-item_count").forEach(function (el) {
    el.textContent = $quantity;
  });

  // Toggle pricing class and subscription box
  const bbAddedItemsTotal = document.querySelector(".bb-added-items-total");
  if (bbAddedItemsTotal) bbAddedItemsTotal.classList.toggle("one-time-purchase-price", $quantity >= 3);

  document.querySelectorAll(".recharge-subscriptions-new-style").forEach(function (el) {
    el.classList.toggle("show-recharge-subscriptions-new-style", $quantity >= 1);
  });

  document.querySelectorAll(".free-shipping-progress-bar").forEach(function (el) {
    el.classList.toggle("only-one-product-added", $quantity == 1);
    el.classList.toggle("five-products-added", $quantity == 5);
  });

  // Set free shipping and progress text based on quantity
  const progressTextMap = {
    0: "You're 2 products away from free shipping!",
    1: "You're 1 product away from free shipping!",
    2: "Add 1 more product for 15% off",
    3: "Add 2 more product for 20% off",
    4: "Add 1 more product for 20% off",
    5: "20% off unlocked",
  };

  document.querySelectorAll(".free-shipping-bar-text").forEach(function (el) {
    el.textContent = progressTextMap[$quantity] || progressTextMap[0];
  });

  // Progress bars and savings info
  document.querySelectorAll(".left-side-progress-bar1").forEach(function (el) { el.classList.toggle("active-progress-bar", $quantity >= 1); });
  document.querySelectorAll(".left-side-progress-bar2").forEach(function (el) { el.classList.toggle("active-progress-bar", $quantity >= 2); });
  document.querySelectorAll(".middle-side-progress-bar").forEach(function (el) { el.classList.toggle("active-progress-bar", $quantity >= 3); });
  document.querySelectorAll(".right-side-progress-bar1").forEach(function (el) { el.classList.toggle("active-progress-bar", $quantity >= 4); });
  document.querySelectorAll(".right-side-progress-bar2").forEach(function (el) { el.classList.toggle("active-progress-bar", $quantity >= 5); });

  document.querySelectorAll(".free-shipping-bar-text-info .free-shipping-text").forEach(function (el) { el.classList.toggle("active-progress-area", $quantity >= 2); });
  document.querySelectorAll(".save-percentage-text.save-percentage-text1").forEach(function (el) { el.classList.toggle("active-progress-area", $quantity >= 3); });
  document.querySelectorAll(".save-percentage-text.save-percentage-text2").forEach(function (el) { el.classList.toggle("active-progress-area", $quantity >= 5); });

  // Determine discount based on quantity
  if ($quantity >= 3) priceChange = 0.85;
  if ($quantity >= 5) priceChange = 0.8;

  // Check subscription plan
  const selectedInput = document.querySelector(
    'input[name="prductType"]:checked'
  );
  if (selectedInput && selectedInput.value === "2") {
    subscriptionPriceChange = 0.85;
  }

  const originalPrice = totalPrice;
  const discountedPrice = priceChange * totalPrice * subscriptionPriceChange;

  const moneyFormat =
    (window.theme && window.theme.moneyFormat) ||
    Shopify.money_format ||
    "${{amount}}";

  const originalPriceFormatted = Shopify.formatMoney(
    Math.round(originalPrice),
    moneyFormat
  );
  const newPriceFormatted = Shopify.formatMoney(
    Math.round(discountedPrice),
    moneyFormat
  );

  document.querySelectorAll(".bb-original-price").forEach(function (el) {
    el.innerHTML = originalPriceFormatted;
    el.style.display = "";
  });
  document.querySelectorAll(".sub-total-price").forEach(function (el) {
    el.innerHTML = newPriceFormatted;
    el.style.display = "";
  });

  if (originalPrice === 0) {
    const bbSavings = document.querySelector(".bb-savings");
    if (bbSavings) bbSavings.classList.add("hide-savings");
    document.querySelectorAll(".bb-original-price").forEach(function (el) { el.style.display = "none"; });
  } else {
    if (originalPrice > discountedPrice) {
      const savings = originalPrice - discountedPrice;
      const savingsFormatted = Shopify.formatMoney(
        (Math.round(savings) / 100).toFixed(2),
        moneyFormat
      );
      // document.querySelectorAll(".bb-savings").forEach(el => { el.innerHTML = savingsFormatted; el.classList.remove("hide-savings"); });
    } else {
      // document.querySelectorAll(".bb-savings").forEach(el => el.classList.add("hide-savings"));
      document.querySelectorAll(".sub-total-price").forEach(function (el) { el.style.display = "none"; });
    }
  }

  document.querySelectorAll(".bb-added-items-total p span:not(.bb-original-price)").forEach(function (el) {
    el.innerHTML = newPriceFormatted;
  });
  if (bbAddedItemsTotal) bbAddedItemsTotal.dataset.price = discountedPrice;
  document.querySelectorAll(".original-total-price").forEach(function (el) { el.innerHTML = originalPriceFormatted; });

  // console.log("Selected value:", selectedInput?.value);
  // console.log("Original:", originalPrice, "| Discounted:", discountedPrice);
}

function initializeProductPopupsAndAccordion() {
  document.querySelectorAll(".view-detail-btn").forEach(function (button) {
    button.addEventListener("click", function (event) {
      event.preventDefault();
      var parentElement = button.closest(".ProductItem__Info-Wrapper");
      var popup = parentElement.querySelector(".popup");
      if (popup) {
        popup.style.display = "block";
        document.body.classList.add("locked-body");
      }
    });
  });

  // Handle popup close
  document.querySelectorAll(".popup .close, .popup-overlay").forEach(function (closeBtn) {
    closeBtn.addEventListener("click", function () {
      var popup = this.closest(".popup");
      if (popup) {
        popup.style.display = "none";
        document.body.classList.remove("locked-body");
      }
    });
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('.popup-content')) {
      e.preventDefault();
      e.stopPropagation();
    }
  });

  var acc = document.getElementsByClassName("dynamic-metafield-accordion");
  for (var i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {
      // First, close all panels
      for (var j = 0; j < acc.length; j++) {
        if (acc[j] !== this) {
          acc[j].classList.remove("metafield-accordion-custom-active");
          var otherPanel = acc[j].nextElementSibling;
          if (otherPanel) {
            otherPanel.classList.remove("active-content");
            otherPanel.style.maxHeight = null;
          }
        }
      }

      // Then, toggle the clicked one
      this.classList.toggle("metafield-accordion-custom-active");
      var panel = this.nextElementSibling;
      if (panel.classList.contains("active-content")) {
        panel.classList.remove("active-content");
        panel.style.maxHeight = null;
      } else {
        panel.classList.add("active-content");
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  }
}

function initSubscriptionToggle() {
  const labels = document.querySelectorAll(".rc-label");
  labels.forEach(function (label) {
    label.addEventListener("click", function () {
      setTimeout(() => {
        let bbTotal = document.querySelector(".bb-added-items-total");
        if (!bbTotal) {
          // console.log("Element .bb-added-items-total not found");
          return;
        }
        // Remove both possible states first
        bbTotal.classList.remove(
          "one-time-purchase-element-active",
          "subscribe-and-save-element-active"
        );

        // Check which label was clicked
        let labelText = label.textContent.trim();
        // console.log("Clicked label:", JSON.stringify(labelText));

        if (labelText.includes("One-Time Purchase")) {
          bbTotal.classList.add("one-time-purchase-element-active");
        } else if (labelText.includes("Subscribe & Save")) {
          bbTotal.classList.add("subscribe-and-save-element-active");
        }
      }, 100);

      // Toggle active label UI
      labels.forEach(function (l) {
        l.classList.remove("active-rc-label");
      });
      label.classList.add("active-rc-label");
    });
  });
}

function initializePurchaseLabelListeners() {
  const labels = document.querySelectorAll(".rc-label");

  labels.forEach(function (label) {
    label.addEventListener("click", function () {
      setTimeout(() => {
        let bbTotal = document.querySelector(".bb-added-items-total");

        if (!bbTotal) {
          // console.log("Element .bb-added-items-total not found");
          return;
        }

        bbTotal.classList.remove(
          "one-time-purchase-element-active",
          "subscribe-and-save-element-active"
        );

        let labelText = label.textContent.trim();

        if (labelText.includes("One-Time Purchase")) {
          bbTotal.classList.add("one-time-purchase-element-active");
        } else if (labelText.includes("Subscribe & Save")) {
          bbTotal.classList.add("subscribe-and-save-element-active");
        }
      }, 100);

      labels.forEach(function (l) {
        l.classList.remove("active-rc-label");
      });
      label.classList.add("active-rc-label");
    });
  });
}

function initializeEqualHeightGridItems() {
  function setEqualHeight() {
    var maxHeight = 0;
    document.querySelectorAll(".create-your-bundle-grid-cell-item").forEach(function (el) {
      var thisHeight = el.offsetHeight;
      if (thisHeight > maxHeight) {
        maxHeight = thisHeight;
      }
    });
    document.querySelectorAll(".create-your-bundle-grid-cell-item").forEach(function (el) {
      el.style.height = maxHeight + "px";
    });
  }

  setEqualHeight();

  window.addEventListener("resize", function () {
    document.querySelectorAll(".create-your-bundle-grid-cell-item").forEach(function (el) {
      el.style.height = "";
    });
    setEqualHeight();
  });
}

function initializeMobileBundleToggle() {
  document.addEventListener("click", async function (e) {
    const arrow = e.target.closest(".down-arrow-svg-element");
    if (!arrow) return;
    const content = arrow.closest(".bb-added-items-content");
    if (content) content.classList.toggle("active-bb-added-items-container");
    document.querySelectorAll(".bundle-box-divider-line").forEach(function (el) {
      el.classList.toggle("active-divider");
    });
    // console.log("arrow-clicked");
  });

  document.addEventListener("click", async function (e) {
    const btn = e.target.closest(".bottom-view-detail-btn");
    if (!btn) return;
    e.preventDefault();
    const arrow = document.querySelector(".down-arrow-svg-element");
    if (arrow) arrow.click();
    // console.log("bottom-view-detail-btn-clicked");
  });
}

function initializeProductTypeListener() {
  const productTypeRadios = document.querySelectorAll(
    'input[name="prductType"]'
  );
  const customFrequencySelect = document.getElementById("custom-frequency");
  function handleProductTypeChange() {
    const selected = document.querySelector('input[name="prductType"]:checked');
    if (!selected || !customFrequencySelect) return;
    customFrequencySelect.disabled = selected.value === "1";
    updateBundlePrice();
  }
  productTypeRadios.forEach((radio) => {
    radio.addEventListener("change", handleProductTypeChange);
  });
  handleProductTypeChange(); // Initialize on page load
}

function initializeBundleAddToCart() {
  document.addEventListener("click", async function (e) {
    const btn = e.target.closest("a.bb-add-to-cart.bb-add-to-cart-active");
    if (!btn) return;

    // Show loader, hide button text
    const loader = document.querySelector(
      ".bb-add-to-cart-wrapper .bb-add-to-cart span.loader"
    );
    const buttonText = document.querySelector(
      ".bb-add-to-cart-wrapper .bb-add-to-cart span.button_text"
    );

    if (loader && buttonText) {
      loader.style.opacity = 1;
      buttonText.style.opacity = 0;
    }

    // Clear Shopify cart
    await fetch(window.Shopify.routes.root + "cart/clear.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    });

    const selections = [];
    const radioSelector = document.querySelector('input[type="radio"][name="prductType"]:checked');
    const productType = radioSelector ? radioSelector.value : null;
    const customFrequency = document.getElementById("custom-frequency")?.value;
    const mainBundleSelector = document.getElementById("main_bundle_product");

    // Collect selected bundle items
    document.querySelectorAll(".bb-item-active").forEach(function (item) {
      const variant_id = item.dataset.variantId;
      const product_id = item.dataset.productId;
      const selling_plan_id = item.dataset.sellingPlanId;

      // console.log("variant_id:", variant_id);
      // console.log("product_id:", product_id);
      // console.log("selling_plan_id:", selling_plan_id);
      selections.push({
        // collectionId: "301606502587",
        collectionId: "288972898381",
        externalProductId: product_id,
        externalVariantId: variant_id,
        quantity: 1,
        ...(productType == 2 && { sellingPlan: selling_plan_id }),
      });
    });

    // Prepare main bundle product data
    const bundleProductData = {
      productId: mainBundleSelector.dataset.productId,
      variantId: mainBundleSelector.dataset.variantId,
      selling60Plan: mainBundleSelector.getAttribute("data-60-selling-plan-id"),
      selling120Plan: mainBundleSelector.getAttribute("data-120-selling-plan-id"),
      selling240Plan: mainBundleSelector.getAttribute("data-240-selling-plan-id"),
      handle: mainBundleSelector.dataset.handle,
    };

    // Build bundle object
    const bundle = {
      externalVariantId: bundleProductData.variantId,
      externalProductId: bundleProductData.productId,
      selections: selections,
    };

    // console.log(bundle);

    // Get bundle cart items from Recharge
    const cartItems = await recharge.bundle.getDynamicBundleItems(
      bundle,
      bundleProductData.handle
    );

    const cartData = { items: cartItems };

    // Add items to cart
    await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(cartData),
    });

    // Redirect to checkout
    window.location.href = "/checkout";
  });
}

function initializeBundleQuantityControls() {
  // Handle quantity minus
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".bb-quantity .bb-quantity-minus");
    if (!btn) return;

    const quantityWrapper = btn.closest(".bb-quantity");
    const quantityInput = quantityWrapper.querySelector("input");
    const min = parseInt(quantityInput.getAttribute("min"));
    const quantity = parseInt(quantityInput.value);
    const variantId = btn.closest(".bb-free-bag-item").getAttribute("data-variant-id");

    if (quantity > min) {
      const plusBtn = quantityWrapper.querySelector(".bb-quantity-plus");
      if (plusBtn) plusBtn.removeAttribute("disable");
    }

    const addedItems = document.querySelectorAll(`.bb-added-item[data-variant-id="${variantId}"]`);
    if (addedItems.length > 0) {
      const removeBtn = addedItems[0].querySelector(".remove-bb-item");
      if (removeBtn) removeBtn.click();
    }
  });

  // Handle quantity plus
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".bb-quantity .bb-quantity-plus");
    if (!btn) return;

    const quantityWrapper = btn.closest(".bb-quantity");
    const quantityInput = quantityWrapper.querySelector("input");
    const max = parseInt(quantityInput.getAttribute("max"));
    let quantity = parseInt(quantityInput.value);
    const variantId = parseInt(btn.closest("[data-variant-id]").getAttribute("data-variant-id"));

    if (quantity >= max) {
      btn.setAttribute("disable", "disable");
    }

    if (quantity < max && getBundleItemQuantity(variantId) < max) {
      quantity += 1;
      quantityInput.value = quantity;
      quantityInput.dispatchEvent(new Event("change", { bubbles: true }));
      const addProductBtn = btn.closest(".bb-free-bag-item").querySelector(".bb-add-product-bundle");
      if (addProductBtn) addProductBtn.click();
    }
  });

  // Handle manual input change
  function handleQuantityChange(e) {
    const input = e.target.closest(".bb-quantity input");
    if (!input) return;

    const min = parseInt(input.getAttribute("min"));
    const max = parseInt(input.getAttribute("max"));
    let quantity = parseInt(input.value);
    const variantId = parseInt(input.closest("[data-variant-id]").getAttribute("data-variant-id"));

    if (quantity < min && getBundleItemQuantity(variantId) < max) {
      input.value = min;
    } else if (quantity > max) {
      input.value = max;
    }
  }

  document.addEventListener("change", handleQuantityChange);
  document.addEventListener("input", handleQuantityChange);
}

function updateBundleProgressUI(count) {
  let discount = "20%",
    threshold = 5;
  if (count < 5) {
    discount = "20%";
    threshold = 5;
  }
  if (count < 4) {
    discount = "15%";
    threshold = 4;
  }
  if (count < 3) {
    discount = "15%";
    threshold = 3;
  }
  if (count < 2) {
    discount = "15%";
    threshold = 2;
  }

  const diff = threshold - count;
  const text =
    count === 3
      ? "Congratulations! You get 15% Off"
      : `Add ${diff} more ${diff === 1 ? "Item" : "Items"} to Get ${discount} off`;

  if (count == 1) {
    const el = document.querySelector('.bb-added-item:nth-child(2) .bb-added-item-text');
    if (el) el.textContent = 'Add 1 more & get free shipping';
  } else if (count == 2) {
    const el = document.querySelector('.bb-added-item:nth-child(3) .bb-added-item-text');
    if (el) el.textContent = 'Add 1 more and save 15%';
  } else if (count == 3) {
    const el = document.querySelector('.bb-added-item:nth-child(5) .bb-added-item-text');
    if (el) el.textContent = 'Add 2 more and save 20%';
  } else if (count == 4) {
    const el = document.querySelector('.bb-added-item:nth-child(5) .bb-added-item-text');
    if (el) el.textContent = 'Add 1 more and save 20%';
  }

  document.querySelectorAll(".bb-progress-text").forEach(function (el) { el.textContent = text; });

  document.querySelectorAll(".bb-add-to-cart").forEach(function (btn) {
    const buttonText = btn.querySelector(".button_text");
    if (count >= 2) {
      if (buttonText) buttonText.textContent = "Add Bundle to Cart";
      btn.classList.add("bb-add-to-cart-active");
    } else {
      if (buttonText) buttonText.textContent = `Add ${diff} more`;
      btn.classList.remove("bb-add-to-cart-active");
    }
  });
}

function updateCallActionPlaceholders(count) {
  const countDiff = 3 - count;
  const placeholders = [countDiff, countDiff + 1, countDiff + 2];

  document.querySelectorAll(".bb-item-call-action:not(.bb-item-active) h3").forEach(function (el, i) {
    const itemCount = placeholders[i];
    const text = `Add ${itemCount} more ${itemCount === 1 ? "Item" : "Items"} & save 20%`;
    el.innerHTML = text;
  });
}

function initializeAddToBundle() {
  document.addEventListener("click", function (e) {
    const clickedBtn = e.target.closest(".bb-add-product-bundle");
    if (!clickedBtn) return;

    const target = clickedBtn.closest(".bb-free-bag-item");
    const variantId = target.dataset.variantId;
    const selling60Plan = target.getAttribute("data-60-selling-plan-id");
    const selling120Plan = target.getAttribute("data-120-selling-plan-id");
    const selling240Plan = target.getAttribute("data-240-selling-plan-id");
    const productId = target.dataset.productId;
    const variantName = target.dataset.name;
    const image = target.dataset.image;
    const price = parseFloat(target.dataset.price);
    const title = target.querySelector("h2")?.innerHTML;
    const priceFormat = target.dataset.priceFormat;
    const twentyFourDays = target.getAttribute("data-24-days");
    const fortyEightDays = target.getAttribute("data-48-days");
    const ninetySixDays = target.getAttribute("data-96-days");
    const maxAllowed = parseInt(target.dataset.max);
    const currentQty = getBundleItemQuantity(variantId);
    subscriptionInput();
    if (currentQty >= maxAllowed) return;

    target.classList.add("bb-added-to-bundle");

    const placeholder =
      document.querySelector(".bb-added-item.bb-item-active + .bb-item-placeholder") ||
      document.querySelector(".bb-added-items-container > .bb-item-placeholder:first-child");

    const imgContainer = placeholder.querySelector(".bb-added-item-image");
    if (imgContainer) imgContainer.innerHTML = "";

    const itemHTML = `
      <a href="javascript:void(0)" class="remove-bb-item">
        <svg xmlns="http://www.w3.org/2000/svg" width="9.02" height="9.02" viewBox="0 0 9.02 9.02">
          <g transform="translate(0.354 0.353)">
            <path d="M-3487.372-4476.921l-8.312-8.313" transform="translate(3495.685 4485.234)" fill="none" stroke="#fff" stroke-width="1"/>
            <path d="M8.312,8.313,0,0" transform="translate(8.313 0) rotate(90)" fill="none" stroke="#fff" stroke-width="1"/>
          </g>
        </svg>
      </a>
      <img src="${image}" alt="" />
    `;

    placeholder.setAttribute("data-variant-id", variantId);
    placeholder.setAttribute("data-name", variantName);
    placeholder.setAttribute("data-product-id", productId);
    placeholder.setAttribute("data-24-days", twentyFourDays);
    placeholder.setAttribute("data-48-days", fortyEightDays);
    placeholder.setAttribute("data-96-days", ninetySixDays);
    placeholder.setAttribute("data-image", image);
    placeholder.setAttribute("data-selling-plan-id", selling60Plan);
    placeholder.setAttribute("data-60-selling-plan-id", selling60Plan);
    placeholder.setAttribute("data-120-selling-plan-id", selling120Plan);
    placeholder.setAttribute("data-240-selling-plan-id", selling240Plan);
    placeholder.classList.remove("bb-item-placeholder");
    placeholder.classList.add("bb-item-active");

    const titleEl = placeholder.querySelector(".bb-added-item-title");
    if (titleEl) titleEl.innerHTML = variantName;
    if (imgContainer) imgContainer.innerHTML = itemHTML;

    // Update count, price, UI
    const totalEl = document.querySelector(".bb-added-items-total");
    const oldTotal = totalEl ? (parseFloat(totalEl.dataset.price) || 0) : 0;
    if (totalEl) totalEl.dataset.price = oldTotal + price;

    const totalInput = document.getElementById("total_bundle_products");
    const oldCount = totalInput ? parseInt(totalInput.value) : 0;
    const newCount = oldCount + 1;
    if (totalInput) totalInput.value = newCount;

    updateBundleProgressUI(newCount);
    updateCallActionPlaceholders(newCount);

    document.querySelectorAll(".recharge-subscriptions-new-style").forEach(function (el) {
      el.style.display = newCount >= 1 ? "" : "none";
    });
    document.querySelectorAll(".shipping-price-element").forEach(function (el) {
      el.style.display = newCount >= 2 ? "" : "none";
    });

    saveToBundleMetadata(variantId, 1);
    updateBundlePrice();
  });
}

function initializeRemoveFromBundle() {
  document.addEventListener("click", function (e) {
    const removeBtn = e.target.closest(".remove-bb-item");
    if (!removeBtn) return;

    const target = removeBtn.closest(".bb-item-active");
    if (!target) return;

    const variantId = target.dataset.variantId;
    const count = document.querySelectorAll(".bb-item-active").length;

    target.remove();

    // Add placeholder back
    const placeholderHTML = `
      <div class="each-row bb-added-item bb-item-placeholder bb-item-call-action">
        <div class="bb-added-item-inner">
          <div class="bb-added-item-image">
            <img src="https://cdn.shopify.com/s/files/1/0245/5296/4170/files/Vector_22.svg?v=1742185319" alt="placeholder-bottle-image">
          </div>
          <div class="bb-added-item-title"></div>
          <div class="bb-added-item-text">&nbsp;</div>
        </div>
      </div>`;
    const container = document.querySelector(".bb-added-items-container");
    if (container) container.insertAdjacentHTML("beforeend", placeholderHTML);

    // Update placeholder text
    const textMap = [
      "",
      "Buy 2, get free shipping",
      "Buy 3, get 15% off",
      "",
      "Buy 5, get 20% off",
    ];
    document.querySelectorAll(".bb-added-items-container .bb-added-item").forEach(function (item, index) {
      const textEl = item.querySelector(".bb-added-item-text");
      if (!textEl) return;
      textEl.textContent = textMap[index] || "";
      if (textEl.textContent.trim() === "") {
        item.classList.add("hide-bb-added-item-without-text-element");
      } else {
        item.classList.remove("hide-bb-added-item-without-text-element");
      }
    });

    // Update total count
    const totalInput = document.getElementById("total_bundle_products");
    const oldCount = totalInput ? parseInt(totalInput.value) : 0;
    const newCount = oldCount - 1;
    if (totalInput) totalInput.value = newCount;

    updateBundleProgressUI(newCount);
    updateCallActionPlaceholders(newCount);

    // Update product quantity
    const qtyInput = document.querySelector(`.bb-free-bag-item[data-variant-id="${variantId}"] .bb-quantity input`);
    if (qtyInput) {
      let qty = parseInt(qtyInput.value);
      if (qty > 1) {
        qtyInput.value = qty - 1;
      } else {
        const itemEl = document.querySelector(`.bb-free-bag-item[data-variant-id="${variantId}"]`);
        if (itemEl) itemEl.classList.remove("bb-added-to-bundle");
      }
    }

    document.querySelectorAll(".recharge-subscriptions-new-style").forEach(function (el) {
      el.style.display = newCount >= 1 ? "" : "none";
    });
    document.querySelectorAll(".shipping-price-element").forEach(function (el) {
      el.style.display = newCount >= 2 ? "" : "none";
    });

    saveToBundleMetadata(variantId, -1);
    updateBundlePrice();
  });
}

document.addEventListener("DOMContentLoaded", function () {
  initializeBundleQuantityControls();
  initializeAddToBundle();
  initializeRemoveFromBundle();
  initSubscriptionToggle();
  initializeProductPopupsAndAccordion();
  initializeBundleAddToCart();
  initializeProductTypeListener();
  // initializeEqualHeightGridItems();
  initializePurchaseLabelListeners();
  initializeMobileBundleToggle();
});

document.addEventListener("shopify:section:load", function (event) {
  initializeBundleQuantityControls();
  initializeAddToBundle();
  initializeRemoveFromBundle();
  initSubscriptionToggle();
  initializeProductPopupsAndAccordion();
  initializeBundleAddToCart();
  initializeProductTypeListener();
  // initializeEqualHeightGridItems();
  initializePurchaseLabelListeners();
  initializeMobileBundleToggle();
});

function subscriptionInput() {
  let checkedInput = document.querySelector('.subscribe_label_wrapper input[name="prductType"]:checked');
  if (checkedInput) {
    if (checkedInput.value === "2" && checkedInput.id === "atc_subscription") {
      const el = document.querySelector(".bb-added-items-total");
      if (el) el.classList.add("subscribe-and-save-element-active");
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const frequencySelect = document.getElementById("custom-frequency");
  if (frequencySelect) {
    frequencySelect.addEventListener("change", function () {
      const selectedValue = this.value;
      const dayValue = selectedValue.replace("-days", "");

      document.querySelectorAll(".bb-added-item.bb-item-active").forEach(function (item) {
        const sellingPlanId = item.getAttribute(`data-${dayValue}-selling-plan-id`);
        if (sellingPlanId) {
          item.setAttribute("data-selling-plan-id", sellingPlanId);
        }
      });
    });
  }
});

document.addEventListener("DOMContentLoaded", subscriptionInput);
